"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _actionTypes = require("../modules/base/actionTypes");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const mapStateToProps = function (state) {
  return {
    base: state.base
  };
};
class Show extends _react.default.Component {
  render() {
    const {
      base
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "position-fixed p-3",
      style: {
        bottom: "0",
        right: "0"
      }
    }, /*#__PURE__*/_react.default.createElement("ul", {
      className: "list-group"
    }, base.errors.map((error, index) => /*#__PURE__*/_react.default.createElement("li", {
      key: index,
      className: "list-group-item list-group-item-danger"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "mr-3"
    }, error.Message.length > 120 ? `${error.Message.substring(0, 120)}…` : error.Message), /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: "close",
      "data-dismiss": "alert",
      "aria-label": "Close",
      onClick: () => this.props.dispatch({
        type: _actionTypes.DELETE_BASE_FAILURE,
        data: error
      })
    }, /*#__PURE__*/_react.default.createElement("span", {
      "aria-hidden": "true"
    }, "\xD7"))))));
  }
}
Show.propTypes = process.env.NODE_ENV !== "production" ? {
  base: _propTypes.default.object,
  dispatch: _propTypes.default.func
} : {};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(Show);
module.exports = exports.default;